var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AppToolbar',{on:{"side-icon-click":_vm.handleDrawerVisiable}}),_c('AppDrawer',{attrs:{"show-drawer":_vm.showDrawer}}),_c('v-main',[_c('v-container',{staticClass:"pa-6",attrs:{"fluid":""}},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12","sm":"12"}},[_c('router-view',{key:_vm.$route.path})],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }